export const enum ExtensionMessages {
  CHECK = "PING",
  CONFIRM = "EXTENSION_FOUND",
  AUTH_CHECK = "EXTENSION_AUTH_PING",
  AUTH_SUCCESS = "EXTENSION_AUTH_SUCCESS",
  AUTH_FAILED = "EXTENSION_AUTH_FAILED",
}

export const download_url =
  "https://chromewebstore.google.com/detail/smartsync-smartwiz-data-e/mmjaoplbcngpkdgekmjjcmehlkbpngph?hl=en&authuser=0";

export const article_url =
  "https://intercom.help/smartwiz-support/en/articles/10059048-how-to-use-the-crm-data-entry-chrome-extension-taxwise-demo-included";

export const PROD_EXT_ID = "mmjaoplbcngpkdgekmjjcmehlkbpngph";
export const STAGING_EXT_ID = "jfoekeljkecifldchpbhamnpahmlpabb";
export const DEV_EXT_ID = "ncnkfhedfjjcbneoogjodcncddhgiloj";
// For local development - this will be dynamically injected by the extension
export const LOCAL_EXT_ID = "local-development";
export const EXT_IDS = [PROD_EXT_ID, STAGING_EXT_ID, DEV_EXT_ID];
